module.exports = __webpack_public_path__ + "media/images/webpage/hotels/7167/meal-1ca0913ddcbd34b6a43db88c35996fff.webp";